import React from 'react';
import { useHistory } from 'react-router';
import { StringParam, useQueryParam } from 'use-query-params';
import { Box, CircularProgress } from '@material-ui/core';
import { ConsoleActionButton } from '../../../../../common/ConsoleActionButton';
import { AlertCard } from '../../../../../../../../common/cards/alert-card/AlertCard';
import { useApiUrl } from '../../../../../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../../../../../global/network/useCampfireFetch';

const SEEK_VOLUNTEER_CODE_VERIFIER_KEY = 'seek_volunteer_code_verifier';
const SEEK_VOLUNTEER_REGION_KEY = 'seek_volunteer_region';

export function SeekVolunteerAuthorizationCallback() {
  const campfireFetch = useCampfireFetch<{ config: { accessToken: string } }>({ defer: true });
  const apiUrl = useApiUrl();
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  const history = useHistory();
  const [code] = useQueryParam('code', StringParam);

  React.useEffect(() => {
    const codeVerifier = sessionStorage.getItem(SEEK_VOLUNTEER_CODE_VERIFIER_KEY);
    const region = sessionStorage.getItem(SEEK_VOLUNTEER_REGION_KEY);
    sessionStorage.removeItem(SEEK_VOLUNTEER_CODE_VERIFIER_KEY);
    sessionStorage.removeItem(SEEK_VOLUNTEER_REGION_KEY);

    if (!code || !codeVerifier) {
      setError('Authorization failed. Please try connecting again.');
      setIsLoading(false);
      return;
    }

    campfireFetch
      .run({
        url: `${apiUrl}/wm/auth/callback`,
        method: 'post',
        data: {
          app: 'seek_volunteer',
          code,
          codeVerifier,
          region,
        },
      })
      .then(() => {
        history.push('/admin/admin-console/apps');
      })
      .catch(() => {
        setError('Failed to complete SEEK Volunteer authorization. Please try again.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Box p={3} maxWidth={480}>
        <AlertCard variant='urgent' title='Authorization Failed'>
          {error}
        </AlertCard>
        <Box mt={2}>
          <ConsoleActionButton
            variant='contained'
            color='primary'
            onClick={() => history.push('/admin/admin-console/apps')}
          >
            Return to Apps
          </ConsoleActionButton>
        </Box>
      </Box>
    );
  }

  return null;
}
